import Util from '../../../shared/util/util';

// T4-204: graphql refuses the Salesforce settings writes (PUT/POST /salesforce/*) unless this header carries the
// session's CSRF token. Read on every call, so the current token is always sent.
export const salesforceWriteHeaders = () => {
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	headers.append('X-FORECAST-CSRF-TOKEN', Util.getCsrfValue());
	return headers;
};
